import { useMutation, useQuery } from '@tanstack/react-query';
import { OrderDirection } from '../../common/enums/order-direction.enum';
import { CompanyStatus, ICompanyDTO } from '../../common/interfaces/company.interface';
import { addCompany, getCompanies, updateCompany } from './companies.api';

export const useCompaniesQuery = (
  limit: number,
  page: number,
  search?: string,
  orderBy?: string,
  orderDirection?: OrderDirection,
  status?: CompanyStatus,
) => {
  return useQuery({
    queryKey: ['companies', limit, page, search, orderBy, orderDirection, status],
    queryFn: () => getCompanies(limit, page, search, orderBy, orderDirection, status),
  });
};

export const useAddCompanyMutation = () => {
  return useMutation({
    mutationKey: ['company', 'add'],
    mutationFn: (payload: ICompanyDTO) => addCompany(payload),
  });
};

export const useUpdateCompanyMutation = () => {
  return useMutation({
    mutationKey: ['company', 'update'],
    mutationFn: (payload: ICompanyDTO) => updateCompany(payload),
  });
};
